import { connect } from "react-redux";
import OvTimeInfoActions from "./OvTimeInfoActions";
import {
  setSuccessNotification,
  setErrorNotification
} from "./actions/notifications";
import { createInvoice } from "./actions/invoices";
import { sendToSheetAction } from "./actions/sheets";

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClipboardEvent: (type, evt) => {
      if (type !== "ERROR") {
        const message = `Sucessfully copied ${type} data to the clipboard`;
        dispatch(setSuccessNotification(message));
        return;
      }
      dispatch(setErrorNotification({ message: "Failed to copy" }, evt));
    },
    createInvoice(data) {
      dispatch(createInvoice(data));
    },
    sendToSheet(range, data, tableInfo) {
      dispatch(sendToSheetAction(range, data, tableInfo));
    }
  };
};

const OvTimeInfoActionsContainer = connect(null, mapDispatchToProps)(
  OvTimeInfoActions
);

export default OvTimeInfoActionsContainer;



// WEBPACK FOOTER //
// ./src/OvTimeInfoActionsContainer.js